import { useEffect, useState } from "react"
import { useLocation } from "react-router"
import { Alert, Box } from "@mui/material"
import { ImportExcelSelectedFile } from "./import-excel-selected-file"
import { ImportExcelSpreadsheet } from "./import-excel-spreadsheet"
import { If } from "lib/@components/switch"
import Excel from "exceljs"
import { ExcelImportFileChanged, ImportAssetsExcelFileSelected, ResetExcelImport } from "event-definitions"
import { ExcelUploadLoadError } from "./excel-upload-load-error"

export function AddAssetsImport() {
    const [definition] = useState({})
    const location = useLocation()
    const [file, setFile] = useState(location.state?.file || null)
    const [fileErrorMessage, setFileErrorMessage] = useState("")

    useEffect(() => {
        async function processFile() {
            if (!file) return
            try {
                const workbook = await loadExcel(file)
                ImportAssetsExcelFileSelected.raise({ workbook, file })
            } catch (error) {
                const message = ExcelUploadLoadError(error)
                setFileErrorMessage(message)
                setFile(null)
            }
        }

        processFile()
    }, [file])

    ResetExcelImport.useEvent(() => {
        setFile(null)
        setFileErrorMessage("")
    })

    return (
        <Box>
            {fileErrorMessage && (
                <Alert severity="error" sx={{ mb: 2 }} data-cy="excel-file-error-alert">
                    {fileErrorMessage}
                </Alert>
            )}
            <ImportExcelSelectedFile fileName={file?.name} onFileSelect={handleFileSelect} />
            <If truthy={file}>
                <Box data-cy="add-assets-stepper">
                    <ImportExcelSpreadsheet definition={definition} />
                </Box>
            </If>
        </Box>
    )

    function handleFileSelect(selectedFile) {
        setFileErrorMessage("")
        setFile(selectedFile)
        ExcelImportFileChanged.raise()
    }

    function loadExcel(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()

            reader.onload = async ({ target: { result } }) => {
                try {
                    const workbook = new Excel.Workbook()
                    await workbook.xlsx.load(result)
                    resolve(workbook)
                } catch (error) {
                    reject(error)
                }
            }

            reader.onerror = (error) => reject(error)
            reader.readAsArrayBuffer(file)
        })
    }
}
